export default {
  title: "Algorithms",
  pageTitle: "Course details",
  parentTitle: "Courses",
};
